import { take, put, fork, call } from 'redux-saga/effects';
import * as types from '../constants';
import {ItemsService} from "../../services/ItemsService";
import {
  loadItemsAppend,
  loadItemsDone,
  loadItemsFailed,
  loadItemsLoadingMore,
} from "../actions/itemActions";
import CachedApi from '../../services/cachedApi';
import { getKey } from '../helpers';
import { getSelectorPerPage } from '../../services/pagination';

const loadGenerations = {};

const hasUnknownTotal = (count) => count === null || count === undefined || count < 0;

export function* loadRemainingSelectorPages(model, params, itemsListId, firstPage, generation) {
  const key = getKey(itemsListId, model);
  const perPage = params.per_page || getSelectorPerPage();
  const unknownTotal = hasUnknownTotal(firstPage.count);
  const totalPages = unknownTotal ? Infinity : Math.ceil((firstPage.count || 0) / perPage);
  const remainingValues = [];

  try {
    for (let page = 2; page <= totalPages; page += 1) {
      if (loadGenerations[key] !== generation) {
        return;
      }

      const { data, error } = yield call(
        ItemsService.get,
        model,
        { ...params, page, per_page: perPage },
        CachedApi
      );

      if (error || !data?.values) {
        return;
      }

      remainingValues.push(...data.values);

      // When the backend does not return a real count (e.g. count = null),
      // keep paging until it returns a non-full page.
      if (unknownTotal && data.values.length < perPage) {
        break;
      }
    }

    if (loadGenerations[key] !== generation || !remainingValues.length) {
      return;
    }

    yield put(loadItemsAppend(model, remainingValues, itemsListId));
  } finally {
    if (loadGenerations[key] === generation) {
      yield put(loadItemsLoadingMore(model, itemsListId, false));
    }
  }
}

export function* loadItems(model, params={}, itemsListId) {
  const key = getKey(itemsListId, model);
  const generation = (loadGenerations[key] || 0) + 1;
  loadGenerations[key] = generation;

  const requestParams = {
    ...(params.selector ? { page: 1, per_page: getSelectorPerPage() } : {}),
    ...params,
  };

  const {data, error} = yield call(ItemsService.get, model, requestParams, CachedApi);

  if (loadGenerations[key] !== generation) {
    return;
  }

  if(data){
    yield put(loadItemsDone(model, data, itemsListId ));

    const loadedCount = data.values?.length || 0;
    const perPage = requestParams.per_page || getSelectorPerPage();
    const hasMore = hasUnknownTotal(data.count)
      ? loadedCount === perPage
      : loadedCount < data.count;
    if (params.selector && hasMore) {
      yield put(loadItemsLoadingMore(model, itemsListId, true));
      yield fork(
        loadRemainingSelectorPages,
        model,
        requestParams,
        itemsListId,
        data,
        generation
      );
    }
  } else {
    yield put(loadItemsFailed(model, error,itemsListId));
  }
}

export function* loadItemsHandler() {
  while (true) {
    const { payload } = yield take(types.LOAD_ITEMS);
    const { model, params, itemsListId } = payload;
    yield fork(loadItems, model, params, itemsListId);
  }
}

export default [
  loadItemsHandler
];
